import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../../utils/auth_util';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class CategoryAllFeed extends Base {
  static fetch({ tag, person, magazine, company, page, product }, store) {
    const pageParams = page ? `&page=${page}` : '';
    const total = tag && tag.includes('_advertorial') ? 10 : 20;
    const tagOrPerson = this.cleanParam(tag || person || company || product);
    const state = store.getState();
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheExpire = get(state, 'config.cacheExpire');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const site = get(state, 'config.site');
    const host = get(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
    const protocol = get(state, 'config.protocol') || 'https://';
    const options = {};
    // api has auth in beta
    if (get(state, 'config.authEnabled')) {
      extend(options, authUtil(state));
    }

    const method = magazine ? 'all-posts-tag-slugs' : `posts-tag-slugs/${site}`;
    let cacheKeyUrl = '';
    if (magazine) {
      cacheKeyUrl = `${protocol}${host}/api/v2/${method}/${tagOrPerson}?total=${total}${pageParams}&with_body=0&death_incarnate`;
    } else {
      cacheKeyUrl = `${protocol}${host}/v4/tag/posts/fastcompany/${tagOrPerson}?page_size=${total}${pageParams}&only_new=1&old_fe_tag=1`;
    }
    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;
    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      if (!canUseDOM) {
        log.info(`Requesting: ${cacheKeyUrl} from model.`);
      }
      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
  }
}
